import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button, Box } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

interface PWARegistrationProps {
  children: React.ReactNode;
}

const PWARegistration: React.FC<PWARegistrationProps> = ({ children }) => {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Forzar actualización del service worker
      navigator.serviceWorker
        .register('/sw.js?v=' + new Date().getTime())
        .then((registration) => {
          console.log('SW registrado: ', registration);

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  setShowReload(true);
                  setWaitingWorker(newWorker);
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          console.log('SW registro falló: ', registrationError);
        });

      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    }
  }, []);

  const reloadPage = () => {
    setShowReload(false);
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  return (
    <>
      {children}
      <Snackbar
        open={showReload}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="info"
          action={
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                color="inherit"
                size="small"
                onClick={reloadPage}
                startIcon={<RefreshIcon />}
              >
                Actualizar
              </Button>
            </Box>
          }
        >
          Nueva versión disponible
        </Alert>
      </Snackbar>
    </>
  );
};

export default PWARegistration; 